import React from 'react';
import { useContext } from 'react';
import { UserContexts } from '../../Context/UserContexts';
import Trash from '../../img/trash.png'
import { DivTech } from './styles';

interface ITecnologia{
    title: string;
    status: string;
    id: string;
}

function TechList() {
    const { techs } = useContext(UserContexts)


    const {deleteTech} = useContext(UserContexts);

  return(
    <DivTech>

        {techs?.map((tecnologia:ITecnologia)=>{
            return(
                <li>
                    <h3>{tecnologia.title}</h3>
                    <div>
                        <p>{tecnologia.status}</p>
                        <button className='trashTech' onClick={()=>deleteTech(tecnologia.id)}><img src={Trash} alt="lixeira para apagar a tech" /></button>
                    </div>
                </li>
            )})
            }
    </DivTech>
  );
}

export default TechList;